/**
 * 创建echarts hooks
 */

// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  TransformComponent,
} from 'echarts/components'
import * as Echarts from 'echarts/core'
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的组件
Echarts.use([
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  LegendComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
])

export const useCharts = ({ id }) => {
  let chartInstance = null
  // 初始化
  const initCharts = () => {
    const el = document.getElementById(id)
    if (!chartInstance && el) {
      // 初始化 ECharts 实例
      chartInstance = Echarts.init(el)
    }
  }

  // 设置值
  const setOption = (options) => {
    if (chartInstance) {
      chartInstance.setOption(options)
    }
  }

  // 设置加载显示
  const setLoading = (loading) => {
    if (chartInstance) {
      if (loading) {
        chartInstance.showLoading()
      } else chartInstance.hideLoading()
    }
  }

  // 销毁
  const disposeCharts = () => {
    if (chartInstance) {
      // 销毁 ECharts 实例
      chartInstance.dispose()
      chartInstance = null
    }
  }

  return {
    initCharts,
    chartInstance,
    setOption,
    setLoading,
    disposeCharts,
  }
}
